module.exports = __webpack_public_path__ + "logo_rvcnn_rovcanin_jewellry_design_fashion.jpg?d437d842c40b933319f888aece4bacff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/rvcnn/logo_rvcnn_rovcanin_jewellry_design_fashion.jpg
// module id = 96
// module chunks = 0